import { FC, SyntheticEvent } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import LocalDiningIcon from '@mui/icons-material/LocalDining';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Dialog from 'components/Dialog';
import RoomRatesEditorCateringSettings from 'components/RoomRatesEditorCateringSettings';

import { RoomRatesEditorSettingsMenuCatering_package$key } from '__generated__/RoomRatesEditorSettingsMenuCatering_package.graphql';
import { RoomRatesEditorSettingsMenuCatering_data$key } from '__generated__/RoomRatesEditorSettingsMenuCatering_data.graphql';

type Props = {
  package: RoomRatesEditorSettingsMenuCatering_package$key;
  data: RoomRatesEditorSettingsMenuCatering_data$key;
};

const RoomRatesEditorSettingsMenuCatering: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment RoomRatesEditorSettingsMenuCatering_package on Package {
        ...RoomRatesEditorCateringSettings_package
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment RoomRatesEditorSettingsMenuCatering_data on Query {
        ...RoomRatesEditorCateringSettings_data
      }
    `,
    props.data
  );

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClick={(event: SyntheticEvent) => event.stopPropagation()}
      activateButton={open => (
        <MenuItem onClick={open}>
          <ListItemIcon>
            <LocalDiningIcon />
          </ListItemIcon>

          <ListItemText>Maitinimo nustatymai</ListItemText>
        </MenuItem>
      )}>
      <RoomRatesEditorCateringSettings package={pack} data={data} />
    </Dialog>
  );
};

export default RoomRatesEditorSettingsMenuCatering;
